export default "__VITE_ASSET__CPCjlNhm__"